function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Instagram_icon_svg__cls-2{fill:#fff}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Instagram_icon_svg__Warstwa_2",
  "data-name": "Warstwa 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Instagram_icon_svg___3",
  "data-name": 3
}, /*#__PURE__*/React.createElement("circle", {
  cx: 23.5,
  cy: 23.5,
  r: 23.5,
  fill: "#21374d"
}), /*#__PURE__*/React.createElement("path", {
  className: "Instagram_icon_svg__cls-2",
  d: "M28.09 35.5h-9.18a7.42 7.42 0 01-7.41-7.41v-9.18a7.42 7.42 0 017.41-7.41h9.17a7.42 7.42 0 017.41 7.41v9.17a7.42 7.42 0 01-7.4 7.42zm-9.18-21.32a4.74 4.74 0 00-4.74 4.74v9.17a4.74 4.74 0 004.74 4.74h9.17a4.74 4.74 0 004.74-4.74v-9.18a4.74 4.74 0 00-4.74-4.74z"
}), /*#__PURE__*/React.createElement("path", {
  className: "Instagram_icon_svg__cls-2",
  d: "M23.5 29.63a6.13 6.13 0 116.13-6.13 6.14 6.14 0 01-6.13 6.13zm0-9.86a3.73 3.73 0 103.73 3.73 3.73 3.73 0 00-3.73-3.73z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "Instagram_icon_svg__cls-2",
  cx: 29.94,
  cy: 17.01,
  r: 1.04
})));

function SvgInstagramicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 47 47"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0NyA0NyI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiMyMTM3NGQ7fS5jbHMtMntmaWxsOiNmZmY7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5aYXPDs2IgMTwvdGl0bGU+PGcgaWQ9IldhcnN0d2FfMiIgZGF0YS1uYW1lPSJXYXJzdHdhIDIiPjxnIGlkPSJfMyIgZGF0YS1uYW1lPSIzIj48Y2lyY2xlIGNsYXNzPSJjbHMtMSIgY3g9IjIzLjUiIGN5PSIyMy41IiByPSIyMy41Ii8+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMjguMDksMzUuNUgxOC45MWE3LjQyLDcuNDIsMCwwLDEtNy40MS03LjQxVjE4LjkxYTcuNDIsNy40MiwwLDAsMSw3LjQxLTcuNDFoOS4xN2E3LjQyLDcuNDIsMCwwLDEsNy40MSw3LjQxdjkuMTdBNy40Miw3LjQyLDAsMCwxLDI4LjA5LDM1LjVaTTE4LjkxLDE0LjE4YTQuNzQsNC43NCwwLDAsMC00Ljc0LDQuNzR2OS4xN2E0Ljc0LDQuNzQsMCwwLDAsNC43NCw0Ljc0aDkuMTdhNC43NCw0Ljc0LDAsMCwwLDQuNzQtNC43NFYxOC45MWE0Ljc0LDQuNzQsMCwwLDAtNC43NC00Ljc0WiIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTIzLjUsMjkuNjNhNi4xMyw2LjEzLDAsMSwxLDYuMTMtNi4xM0E2LjE0LDYuMTQsMCwwLDEsMjMuNSwyOS42M1ptMC05Ljg2YTMuNzMsMy43MywwLDEsMCwzLjczLDMuNzNBMy43MywzLjczLDAsMCwwLDIzLjUsMTkuNzdaIi8+PGNpcmNsZSBjbGFzcz0iY2xzLTIiIGN4PSIyOS45NCIgY3k9IjE3LjAxIiByPSIxLjA0Ii8+PC9nPjwvZz48L3N2Zz4=";
export { SvgInstagramicon as ReactComponent };